import { ValidatorFn, FormControl } from '@angular/forms';

export const isValidTimeStringValidatorFn: ValidatorFn = (control: FormControl) => {
  if (control.value === null || control.value === '') {
    return null;
  }

  const [hoursString, minutesString] = control.value.split(':');
  const hours = parseInt(hoursString, 10);
  const minutes = parseInt(minutesString, 10);

  const conditions = [
    isNaN(hours),
    isNaN(minutes),
    hoursString?.length > 2,
    minutesString?.length !== 2,
    isNaN(parseInt(minutesString?.[1], 10)),
    hoursString?.[1] && isNaN(parseInt(hoursString[1], 10)),
    hours < 0,
    minutes < 0,
    minutes > 59,
  ];

  if (conditions.some((condition) => condition)) {
    return { invalidTimeString: true };
  }

  return null;
};
